module.exports = __webpack_public_path__ + "static/media/collinsAerospace.3ecdec65.svg";